import { render, staticRenderFns } from "./SelectCopyPublic.vue?vue&type=template&id=4170f1ef&"
import script from "./SelectCopyPublic.vue?vue&type=script&lang=js&"
export * from "./SelectCopyPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4170f1ef')) {
      api.createRecord('4170f1ef', component.options)
    } else {
      api.reload('4170f1ef', component.options)
    }
    module.hot.accept("./SelectCopyPublic.vue?vue&type=template&id=4170f1ef&", function () {
      api.rerender('4170f1ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/subjects/SelectCopyPublic.vue"
export default component.exports